import { TOpenWindowOptions } from './openWindow.types';

export async function openWindow(url: string | URL, options?: TOpenWindowOptions): Promise<WindowProxy | null> {
  return new Promise(resolve => {
    // Safari cannot open new windows after an async operation - to solve it, we wrap it in a timeout
    setTimeout(() => {
      const popup = window.open(
        url,
        options?.target,
        options?.dimensions
          ? `toolbar=no,scrollbars=no,location=no,resizable=no, width=${options?.dimensions.width}, height=${options?.dimensions.height}, left=${options?.dimensions.left}, top=${options?.dimensions.top}`
          : undefined,
      );

      resolve(popup);
    });
  });
}
